export default __webpack_public_path__ + "static/media/mail-chimp.1882e0b4.svg";